import { createContext } from 'react';

type ContentfulContextType = {
    contentfulClient?: unknown;
    contentfulData: any;
};

export const ContentfulContext = createContext<ContentfulContextType>({} as ContentfulContextType);
